export enum SortedStatus {
  SORTED_DESCENDING = 'sorted descending',
  SORTED_ASCENDING = 'sorted ascending',
}
